import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {finalize, Observable, take} from 'rxjs';
import {AppraiserLoadingService} from "./loading.service";

export const appraiserLoadingInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const _loadingService: AppraiserLoadingService = inject(AppraiserLoadingService);
  let handleRequestsAutomatically: boolean = false;

  _loadingService.auto$
    .pipe(take(1))
    .subscribe((value: boolean): void => {
      handleRequestsAutomatically = value;
    });

  // If the Auto mode is turned off, do nothing
  if (!handleRequestsAutomatically) {
    return next(req);
  }

  // Set the loading status to true
  if (window.location.pathname !== '/access-denied')
    _loadingService._setLoadingStatus(true, req.url);

  return next(req).pipe(
    finalize((): void => {
      // Set the status to false if there are any errors or the request is completed
      _loadingService._setLoadingStatus(false, req.url);
    }));
};
